import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';

import RadioWidget, {
  RadioWidgetType,
} from 'components/UI/Form/Widget/RadioWidget/RadioWidget';

import styles from './RadioGroupRow.module.scss';

export default function RadioGroupRow({
  classes,
  name,
  hasError,
  options,
  value,
  ...props
}: RadioGroupFieldType): JSX.Element {
  return (
    <div className={classNames(styles.container, classes?.container)}>
      {options.map(option => (
        <div
          key={option.value}
          className={classNames(styles.option, classes?.option)}
        >
          <RadioWidget
            name={name}
            checked={option.value === value}
            error={hasError ?? false}
            {...props}
            {...option}
          />
        </div>
      ))}
    </div>
  );
}

export type RadioGroupFieldType = Omit<
  HTMLAttributes<HTMLDivElement>,
  'onChange'
> & {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  classes?: RadioGroupRowClassesType;
  name: string;
  hasError?: boolean;
  value?: string;
  options: Omit<RadioWidgetType, 'name'>[];
};

type RadioGroupRowClassesType = { container?: string; option?: string };
